"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.siloTypes = void 0;
exports.siloTypes = {
    RESET: 'SILO TRANSACTIONS TYPES RESET',
    SET_HEX: 'SILO TRANSACTIONS TYPES SET HEX',
    ON_DELETE: 'SILO TRANSACTION TYPES ON DELETE',
    SET_ERROR: 'SILO TRANSACTION TYPES SET ERROR',
    SET_STATUS: 'SILO TRANSACTION TYPES SET STATUS',
    ON_PUSH_LED: 'SILO TRANSACTION TYPES ON PUSH LED',
    GET_DROPDOWN: 'SILO TRANSACTION TYPES GET DROPDOWN',
    SET_DATA_GRID: 'SILO TRANSACTION TYPES GET DATA GRID',
    ON_SORT_CHANGE: 'SILO TRANSACTION TYPES ON SORT CHANGE',
    ON_PAGE_CHANGE: 'SILO TRANSACTION TYPES ON PAGE CHANGE',
    ON_MUTATION_CLICK: 'SILO TRANSACTION TYPES ON MUTATION',
    SET_DATA_HAULER: 'SILO TRANSACTION TYPES GET DATA HAULER',
    GET_HAULER_LIST: 'SILO TRANSACTION TYPES GET HAULER LIST',
    ON_FILTER_CHANGE: 'SILO TRANSACTION TYPES ON FILTER CHANGE',
    ON_SAVE_DATAITEM: 'SILO TRANSACTION TYPES ON SAVE DATAITEM',
    SET_DATA_HISTORY: 'SILO TRANSACTION TYPES GET DATA HISTORY',
    GET_HAULER_BY_NO: 'SILO TRANSACTION TYPES GET HAULER BY NO',
    ON_CHANGE_DATAITEM: 'SILO TRANSACTION TYPES ON CHANGE DATAITEM',
    SET_DATA_SILO_CONFIG: 'SILO TRANSACTION TYPES GET DATA SILO CONFIG',
    SET_DATA_HOPPER: 'SILO TRANSACTION HOPPER TYPES SET DATA HOPPER TAB',
    ON_PAGE_CHANGE_HISTORY: 'SILO TRANSACTIONS TYPES ON PAGE CHANGE HISTORY',
    SET_SUBMIT_LOADING: 'SILO TRANSACTIONS TYPES SET SUBMIT LOADING',
    HAULER_NOT_FOUND: 'SILO TRANSACTIONS TYPES HAULER NOT FOUND',
};
